<template>
  <div>
    <!-- Year selection label -->
    <label
      for="year-select"
      class="block mb-1.5 text-sm font-medium text-gray-900"
    >
      Årstal
    </label>
    <!-- Year selection dropdown -->
    <select
      id="year-select"
      v-model="selectedYearLocal"
      name="year"
      class="bg-neutral-50 border border-neutral-300 border-solid text-neutral-900 text-sm rounded-lg focus:ring-neutral-500 focus:border-neutral-500 block w-full p-2.5"
    >
      <option v-for="year in yearRange" :key="year" :value="year">
        {{ year }}
      </option>
    </select>
  </div>
</template>

<script setup>
import { ref, computed, watch, defineEmits, defineProps } from "vue";

// Define props
const props = defineProps({
  selectedYear: {
    type: Number,
    required: true,
  },
});

// Define emits
const emit = defineEmits(["update:selectedYear"]);

// Local state
const selectedYearLocal = ref(props.selectedYear);

// Computed property for year range
const yearRange = computed(() => {
  const currentYear = new Date().getFullYear();
  return Array.from({ length: 26 }, (_, i) => currentYear - 4 + i);
});

// Watchers to sync local state with props
watch(selectedYearLocal, (newValue) => {
  emit("update:selectedYear", newValue);
});

watch(
  () => props.selectedYear,
  (newValue) => {
    selectedYearLocal.value = newValue;
  }
);
</script>